export function removerQuebrasDeLinha(value) {
  return value ? value.replace(/[\r\n]+/gm, ' ') : null;
}
